<template>
  <w-settings-content-template>
    <div slot="content">
      <el-row class="title-bar vertical-center-box" type="flex" justify="space-between">
        <div class="title-h3">
          수집 서버 설정
        </div>
        <div>
          <el-button size="mini" type="primary" :disabled="checkPathFlag" @click="updateCollectPath">저장</el-button>
          <el-button class="cmp-margin-left" :disabled="checkPathFlag" @click="resetCollectPath" size="mini">취소</el-button>
        </div>
      </el-row>
      <hr class="mr-b20" />
      <el-row class="gray-box mr-b30">
        <el-col :span="12">
          <el-row type="flex" class="vertical-center-box">
            <el-col class="tit" :span="4">
              로그 저장 위치
            </el-col>
            <el-col :span="20">
              <el-input v-model="logSaveDirectory"></el-input>
            </el-col>
          </el-row>
        </el-col>
      </el-row>
      <div class="title-h3 title-bar">
        <div class="vertical-center-box">
          <div class="mr-r15">수집 서버 목록</div>
          <el-button size="mini" @click="searchCollector" type="primary" class="mr-r4">장비탐색</el-button>
          <el-button size="mini" @click="deleteCollector" :disabled="isExist">장비 삭제</el-button>
        </div>
      </div>
      <el-row>
        <el-table-wrapper ref="dataIndexTable" :column-default="columnDefault" row-class-name="c-dblclick" :data="dataIndexData" :columns="dataIndexColumns"
        highlight-current-row :show-custom-header="false" header-align="center" :show-search-tool="showSearchTool" @row-dblclick="openUpdatePopup" @selection-change="checkBoxSelection">
        </el-table-wrapper>
      </el-row>
      <w-collector-update-popup ref="collectorUpdatePopup" :selectedRow="selectedRow" @loadData="loadData"/>
    </div>
  </w-settings-content-template>
</template>

<script>
import { cloneDeep, isNil, isEmpty } from 'lodash';

import { columnDefault } from '@/constants/table';
import CellEditingMixin from '@/mixins/table/cell-editing';
import WSettingsContentTemplate from '@/components/template/SettingsContentTemplate';
import LogCollectorAPI from '@/api/settings/log/lms-collector-setting';
import msgUtil from '@/utils/message';
import { EMPTY_TEXT } from '@/utils/string';
import { getDateToString } from '@/utils/date';

import WCollectorUpdatePopup from './popup/CollectorUpdatePopup';

export default {
  name: 'WLogCollectionServer',
  mixins: [CellEditingMixin],
  components: {
    WSettingsContentTemplate,
    WCollectorUpdatePopup,
  },
  data() {
    return {
      isExist: true,
      logSaveDirectory: '',
      columnDefault,
      dataIndexData: [],
      dataIndexColumns: [
        {
          headerAlign: 'center',
          align: 'center',
          type: 'selection',
          width: '50',
          prop: 'check_flag',
        },
        {
          label: '수집 서버명',
          prop: 'logCollectorName',
          sortable: true,
        },
        {
          label: 'IP 주소',
          prop: 'logCollectorIpaddress',
          sortable: true,
        },
        {
          label: '등록일',
          prop: 'registDatetime',
          sortable: true,
          formatter: this.getDateFormatter,
        },
      ],
      title: '저장소 관리',
      nodeData: null,
      selectPhysicalNode: null,
      firstKey: null,
      showSearchTool: false,
      selectedRow: null,
      originDirectory: null,
      deleteCollectorList: [],
      checkPathFlag: true,
    };
  },
  mounted() {
    this.loadData();
    this.loadCollectPath();
  },
  watch: {
    logSaveDirectory() {
      this.checkPathFlag = (this.originDirectory === this.logSaveDirectory);
    },
  },
  methods: {
    /**
     * 장비 재탐색
     * @author leesy918
     * @return {[type]} [description]
     */
    searchCollector() {
      LogCollectorAPI.searchLogCollector().then((response) => {
        if (response.data.success) {
          this.$message(msgUtil.getResultMsgData(msgUtil.action.SET, '수집기', true));
          this.loadData();
        } else {
          this.$message(msgUtil.getResultMsgData(msgUtil.action.SET, '수집기', false));
        }
      }).catch((e) => {
        this.$message(msgUtil.getResultMsgData(msgUtil.action.SET, '수집기', false));
        throw new Error(e);
      });
    },
    /**
     * 수집기 삭제
     * @author leesy918
     * @return {[type]} [description]
     */
    deleteCollector() {
      this.$confirm(...msgUtil.getBasicConfirmData(msgUtil.action.DELETE)).then(() => {
        const params = this.deleteCollectorList;
        LogCollectorAPI.deleteCollector(params).then((response) => {
          if (response.data.success) {
            this.$message(msgUtil.getResultMsgData(msgUtil.action.DELETE, '수집기', true));
            this.loadData();
          } else {
            this.$message(msgUtil.getResultMsgData(msgUtil.action.DELETE, '수집기', false));
          }
        }).catch((e) => {
          this.$message(msgUtil.getResultMsgData(msgUtil.action.DELETE, '수집기', false));
          throw new Error(e);
        });
      }).catch(() => {});
    },
    /**
     * 삭제 데이터 선택 이벤트 함수
     * @author leesy918
     * @param  {[type]} data [description]
     * @return {[type]}      [description]
     */
    checkBoxSelection(data) {
      this.deleteCollectorList = data;
      this.isExist = isEmpty(data);
    },
    getDateFormatter(row, column, value) {
      if (!isNil(value)) {
        return getDateToString(value);
      }
      return EMPTY_TEXT;
    },
    /**
     * 로그 수집 경로 수정
     * @author leesy918
     * @return {[type]} [description]
     */
    updateCollectPath() {
      this.$confirm(...msgUtil.getCustomConfirmData('로그 저장 디렉토리를 변경하면 변경 이전의 로그 파일을 다운로드할 수 없습니다. 변경하시겠습니까?')).then(() => {
        const params = {
          basicinfoSubvalueString: this.logSaveDirectory,
        };
        LogCollectorAPI.updateCollectPath(params).then((response) => {
          if (response.data.success) {
            this.$message(msgUtil.getResultMsgData(msgUtil.action.MODIFY, '저장 경로', true));
            this.loadCollectPath();
          } else {
            this.$message(msgUtil.getResultMsgData(msgUtil.action.MODIFY, '저장 경로', false));
          }
        }).catch((e) => {
          this.$message(msgUtil.getResultMsgData(msgUtil.action.MODIFY, '저장 경로', false));
          throw new Error(e);
        });
      }).catch(() => {});
    },
    resetCollectPath() {
      this.logSaveDirectory = cloneDeep(this.originDirectory);
    },
    /**
     * 로그 수집기 목록 조회
     * @author leesy918
     * @return {[type]} [description]
     */
    loadData() {
      LogCollectorAPI.getCollectorList().then((response) => {
        if (response.data.success) {
          this.dataIndexData = response.data.data;
        }
      }).catch((e) => {
        this.$message(msgUtil.getResultMsgData(msgUtil.action.VIEW, '로그 수집기 목록', false));
        throw new Error(e);
      });
      this.dataIndexData = this.getEditableTableData(this.dataIndexData, this.dataIndexColumns);
      this.resetCellEditing();
    },
    /**
     * 로그 수집 경로 조회
     * @author leesy918
     * @return {[type]} [description]
     */
    loadCollectPath() {
      LogCollectorAPI.getLogCollectPath().then((response) => {
        if (response.data.success) {
          this.logSaveDirectory = cloneDeep(response.data.data.basicinfoSubvalueString);
          this.originDirectory = cloneDeep(response.data.data.basicinfoSubvalueString);
        }
      }).catch((e) => {
        this.$message(msgUtil.getResultMsgData(msgUtil.action.VIEW, '수집 경로', false));
        throw new Error(e);
      });
    },
    /**
     * 팝업 출력 이벤트
     * @author leesy918
     * @param  {[type]} selectedRow [description]
     * @return {[type]}             [description]
     */
    openUpdatePopup(selectedRow) {
      this.selectedRow = cloneDeep(selectedRow);
      this.$nextTick(() => {
        this.$refs.collectorUpdatePopup.open();
      });
    },
  },
};
</script>

<style>

</style>



// WEBPACK FOOTER //
// src/views/settings/log-analysis/Collect/CollectionServer/index.vue